import { render, staticRenderFns } from "./PhpSettingsCard.vue?vue&type=template&id=fb706434&scoped=true"
import script from "./PhpSettingsCard.vue?vue&type=script&lang=js"
export * from "./PhpSettingsCard.vue?vue&type=script&lang=js"
import style0 from "./PhpSettingsCard.vue?vue&type=style&index=0&id=fb706434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb706434",
  null
  
)

export default component.exports